// Mock data for the Cyberfit homepage redesign.
// NOTE: All data below is MOCKED (frontend-only). Images are real Cyberfit CDN assets.

export const announcements = [
  "Showroom open 10-4 weekdays & 10-2 Saturdays",
  "Free shipping insurance on all orders shipped within Australia",
  "All steel frames guaranteed for the life of the product",
  "Family owned & operated in Australia since 2004",
];

// Mega-menu navigation. Each item optionally has `items` (icon links) and a `featured` promo.
export const navLinks = [
  {
    label: "Strength Training",
    href: "/collection/weight-sets",
    items: [
      { label: "Weight Plates & Bars", icon: "Disc", desc: "Olympic sets & bumpers" },
      { label: "Dumbbells", icon: "Dumbbell", desc: "Rubber hex & adjustable" },
      { label: "Workout Racks", icon: "Frame", desc: "Power & half racks" },
      { label: "Weight Benches", icon: "StretchHorizontal", desc: "Flat, incline & FID" },
      { label: "Exercise Machines", icon: "Cog", desc: "Plate & pin loaded" },
      { label: "Weightlifting Accessories", icon: "Wrench", desc: "Belts, straps & more" },
      { label: "Gym Storage", icon: "Boxes", desc: "Racks & organisers" },
    ],
    featured: {
      title: "Olympic Weight Sets",
      subtitle: "Save up to 34% on rubber-coated sets",
      cta: "Shop Weights",
      image:
        "/images/da6262764a2c.jpg",
    },
  },
  {
    label: "Cardio",
    href: "/collection/cardio-machines",
    items: [
      { label: "Treadmills", icon: "Footprints", desc: "Home & commercial" },
      { label: "Cross Trainers", icon: "PersonStanding", desc: "Ellipticals" },
      { label: "Exercise Bikes", icon: "Bike", desc: "Spin, upright & recumbent" },
      { label: "Rowing & Ski Trainers", icon: "Waves", desc: "Air & water rowers" },
      { label: "Step Mills & Climbing", icon: "Mountain", desc: "Stair climbers" },
    ],
    featured: {
      title: "Sole & Matrix Treadmills",
      subtitle: "Gym-quality cardio for your home",
      cta: "Shop Cardio",
      image:
        "/images/712a3c79ea9c.png",
    },
  },
  {
    label: "Package Deals",
    href: "/collection/package-deals",
    items: [
      { label: "Home Gym Packages", icon: "House", desc: "Ready to train" },
      { label: "Garage Gym Bundles", icon: "Warehouse", desc: "Rack + bench + weights" },
      { label: "Commercial Fit-outs", icon: "Building2", desc: "Kit out a facility" },
      { label: "Multistation Gyms", icon: "LayoutGrid", desc: "All-in-one stations" },
    ],
    featured: {
      title: "Garage Gym Starter",
      subtitle: "Complete setups from $1,499",
      cta: "View Packages",
      image:
        "/images/825e0fad6821.jpg",
    },
  },
  {
    label: "Functional Training",
    href: "/collection/functional-training",
    items: [
      { label: "Functional Trainers", icon: "Cable", desc: "Dual adjustable pulleys" },
      { label: "Cable Crossover Machines", icon: "GitFork", desc: "Full range of motion" },
      { label: "Smith Machines", icon: "Columns2", desc: "Guided barbell training" },
      { label: "Home Gyms & Multistation", icon: "LayoutGrid", desc: "Space-saving stations" },
      { label: "Strength Stations", icon: "Activity", desc: "Dual cable machines" },
    ],
    featured: {
      title: "Smith Functional Trainer",
      subtitle: "Two machines in one — save space",
      cta: "Shop Now",
      image:
        "/images/28dac21bef02.jpg",
    },
  },
  {
    label: "Flooring & Mirrors",
    href: "/collection/gym-flooring",
    items: [
      { label: "Rubber Gym Flooring", icon: "Grid3x3", desc: "Loose-laid tiles" },
      { label: "EPDM Premium Tiles", icon: "SquareStack", desc: "Top-tier durability" },
      { label: "Coloured Fleck Tiles", icon: "Palette", desc: "Red, blue & grey" },
      { label: "Shatterproof Mirrors", icon: "PanelTop", desc: "Glassless & safe" },
      { label: "Bulk Flooring Packs", icon: "Layers", desc: "6 to 100 tile packs" },
    ],
    featured: {
      title: "EZFloor Commercial Tiles",
      subtitle: "As used by F45 & Anytime Fitness",
      cta: "Shop Flooring",
      image:
        "/images/df8b80203b60.jpg",
    },
  },
  {
    label: "Boxing & MMA Gear",
    href: "#categories",
    items: [
      { label: "Boxing Bags", icon: "Target", desc: "Hanging & free-standing" },
      { label: "Boxing Gloves", icon: "Hand", desc: "Sparring & bag gloves" },
      { label: "Hand Wraps", icon: "Bandage", desc: "Cotton & gel liners" },
      { label: "Focus Pads & Kick Shields", icon: "Shield", desc: "Coaching gear" },
      { label: "Protective Equipment", icon: "ShieldCheck", desc: "Guards & headgear" },
      { label: "Bag Stands & Brackets", icon: "Anchor", desc: "Wall & floor mounts" },
    ],
    featured: {
      title: "Morgan Boxing Range",
      subtitle: "Bags, gloves & protective gear",
      cta: "Shop Boxing",
      image:
        "/images/03353fe143c6.jpg",
    },
  },
  {
    label: "Accessories",
    href: "#categories",
    items: [
      { label: "Spring Collars", icon: "Circle", desc: "25mm & 28mm" },
      { label: "Barbell Storage", icon: "Boxes", desc: "Wall-mounted racks" },
      { label: "Bands & Pegs", icon: "Spline", desc: "Resistance training" },
      { label: "Squat Wedges & Blocks", icon: "Triangle", desc: "Calf & ankle support" },
      { label: "Recovery & Mobility", icon: "HeartPulse", desc: "Rollers & mats" },
      { label: "Bottles & Shakers", icon: "CupSoda", desc: "Stay hydrated" },
    ],
    featured: {
      title: "Finishing Touches",
      subtitle: "Everything to complete your gym",
      cta: "Shop Accessories",
      image:
        "/images/cdcdd7173a1d.png",
    },
  },
];

export const trustBadges = [
  { icon: "MapPin", title: "Australia-Wide Shipping", sub: "Fast dispatch nationwide" },
  { icon: "ShieldCheck", title: "100% Money Back Guarantee", sub: "Shop with confidence" },
  { icon: "Truck", title: "Fully Insured Delivery", sub: "Covered door to door" },
  { icon: "Headphones", title: "7-Day Australian Support", sub: "Talk to real experts" },
];

// Hero bento banners
export const heroBanners = [
  {
    id: "smith",
    title: "Commercial Smith Functional Trainer",
    subtitle: "Two machines in one — save space, train harder",
    cta: "Shop Machines",
    image:
      "/images/28dac21bef02.jpg",
    size: "tall",
  },
  {
    id: "pilates",
    title: "Total Gym Pilates",
    subtitle: "Full-body reformer training",
    cta: "Discover",
    image:
      "/images/1b0a0d272096.jpg",
    size: "small",
  },
  {
    id: "mirrors",
    title: "Shatterproof Gym Mirrors",
    subtitle: "Glassless, lightweight & safe",
    cta: "Shop Mirrors",
    image:
      "/images/e8f9fe01ad0d.jpg",
    size: "small",
  },
  {
    id: "nuobell",
    title: "Nüobell S — 40KG & 100LB",
    subtitle: "The fastest changing adjustable dumbbells on the planet",
    cta: "Shop Dumbbells",
    image:
      "/images/483c6986f2fb.webp",
    size: "wide",
  },
  {
    id: "garage",
    title: "Transform Your Garage",
    subtitle: "Complete home gym setups",
    cta: "Build Yours",
    image:
      "/images/825e0fad6821.jpg",
    size: "small",
  },
];

export const categories = [
  {
    id: "strength",
    name: "Strength Training",
    desc: "Dumbbells, barbells, Olympic weights, squat racks, benches and more — everything for serious lifting.",
    image:
      "/images/a97f20042b99.jpg",
  },
  {
    id: "cardio",
    name: "Cardio Machines",
    desc: "Treadmills, exercise bikes, rowers and cross trainers to keep every workout intense and varied.",
    image:
      "/images/e97d93c2f2e7.jpg",
  },
  {
    id: "dumbbells",
    name: "Adjustable Dumbbells",
    desc: "Nüobell adjustable dumbbells replace a whole rack in one pair — the fastest changing on the planet.",
    image:
      "/images/b41d3acbd8ed.webp",
  },
  {
    id: "flooring",
    name: "Gym Flooring",
    desc: "Loose-laid rubber flooring for home gyms, studios or full commercial facilities. Budget to EPDM.",
    image:
      "/images/50dc6bdecf7a.jpg",
  },
  {
    id: "machines",
    name: "Exercise Machines",
    desc: "Plate-loaded and pin-loaded machines — leg press, lat pulldown, chest press, seated row & more.",
    image:
      "/images/435e7855e4e1.jpg",
  },
  {
    id: "racks",
    name: "Workout Racks",
    desc: "Power racks, half racks, squat stands and wall-mounted folding racks built for a lifetime.",
    image:
      "/images/5094f17974af.jpg",
  },
  {
    id: "benches",
    name: "Weight Benches",
    desc: "Flat, incline and commercial adjustable benches to anchor your strength setup.",
    image:
      "/images/b30591faef89.png",
  },
  {
    id: "plates",
    name: "Weight Plates & Bars",
    desc: "Rubber Olympic weight sets, bumper plates and barbells rated for heavy daily use.",
    image:
      "/images/da6262764a2c.jpg",
  },
];

export const goals = [
  {
    id: "muscle",
    title: "Build Muscle",
    desc: "Racks, benches, free weights",
    icon: "Dumbbell",
  },
  { id: "cardio", title: "Lose Weight", desc: "Treadmills, bikes & rowers", icon: "HeartPulse" },
  { id: "home", title: "Home Gym", desc: "All-in-one multistations", icon: "House" },
  {
    id: "commercial",
    title: "Commercial Fit-out",
    desc: "Kit out your whole facility",
    icon: "Building2",
  },
];

export const featured = {
  id: "cyberfit-smith-functional-trainer",
  name: "Cyberfit Smith Functional Trainer Machine",
  tagline: '"The centrepiece of any serious home or commercial gym."',
  price: 4995,
  compareAt: 8995,
  rating: 4.9,
  reviews: 42,
  badge: "Save 45%",
  bullets: [
    "Dual-purpose Smith machine + functional trainer",
    "2 x 100kg selectorised weight stacks",
    "Commercial-grade steel frame — guaranteed for life",
    "Includes full cable attachment set",
  ],
  image:
    "/images/72cfe39d4600.png",
};

export const bestSellers = [
  {
    id: "c80-package",
    name: "Cyberfit C80 Multi Functional Smith Machine Custom Gym Package",
    price: 2795,
    compareAt: 3595,
    rating: 4.8,
    image:
      "/images/06f5441cd330.jpg",
  },
  {
    id: "90kg-olympic-set",
    name: "90kg Olympic Weight Set Rubber Coated",
    price: 395,
    compareAt: 595,
    rating: 4.9,
    image:
      "/images/c8a913108d3c.jpg",
  },
  {
    id: "york-enforcer",
    name: "York Enforcer Home Gym",
    price: 1299,
    compareAt: null,
    rating: 4.7,
    image:
      "/images/ea08efbdbc04.jpg",
  },
  {
    id: "leg-press-hack",
    name: "Leg Press Machine Hack Squat 400kg Rating",
    price: 1495,
    compareAt: 1895,
    rating: 4.8,
    image:
      "/images/4a02865fb6f6.jpg",
  },
  {
    id: "hex-dumbbell-set",
    name: "Rubber Hex Dumbbells Set 1-10kg with Rack",
    price: 634.5,
    compareAt: 845,
    rating: 4.9,
    image:
      "/images/bc3d97a59c96.png",
  },
  {
    id: "wall-squat-rack",
    name: "Wall Mounted Squat Rack Folding with J Hooks",
    price: 595,
    compareAt: 795,
    rating: 4.8,
    image:
      "/images/f72729b1146b.jpg",
  },
  {
    id: "functional-trainer-commercial",
    name: "Functional Trainer Light Commercial 100kg Stacks",
    price: 2795,
    compareAt: 2995,
    rating: 4.9,
    image:
      "/images/6bfe94dd5509.jpg",
  },
  {
    id: "sissy-squat",
    name: "Sissy Squat Bench",
    price: 295,
    compareAt: 329,
    rating: 4.6,
    image:
      "/images/756db4ca9cf9.jpg",
  },
];

export const packages = [
  {
    id: "garage",
    title: "Garage Gym Starter",
    desc: "Rack, bench, barbell & 100kg weight set",
    price: 1499,
    image:
      "/images/825e0fad6821.jpg",
  },
  {
    id: "commercial",
    title: "Commercial Fit-out",
    desc: "Full plate-loaded machine line-up",
    price: 24995,
    image:
      "/images/32defdac98ba.jpg",
  },
];

export const blogs = [
  {
    id: "b1",
    category: "Buying Guides",
    title: "How to design the perfect garage gym in 5 steps",
    image:
      "/images/825e0fad6821.jpg",
  },
  {
    id: "b2",
    category: "Training",
    title: "Plate-loaded vs pin-loaded machines: which is right for you?",
    image:
      "/images/32defdac98ba.jpg",
  },
  {
    id: "b3",
    category: "Product Guides",
    title: "Why adjustable dumbbells are a game-changer for small spaces",
    image:
      "/images/483c6986f2fb.webp",
  },
];

export const reviewsMeta = {
  rating: 4.8,
  count: 74,
  source: "Google Reviews",
  dist: { 5: 66, 4: 4, 3: 2, 2: 0, 1: 2 },
};

// Short highlight quotes for the strip under the hero
export const reviewHighlights = [
  { text: "A+++ for service, products and great prices!!", name: "Benny Wong" },
  { text: "The entire process from ordering to collection was great.", name: "Franc" },
  { text: "Good customer service, polite, very helpful and good price.", name: "Steviie Vee" },
];

export const reviews = [
  { name: "K Mack", meta: "Local Guide · 34 reviews", when: "9 months ago", rating: 5, photos: ["/images/a97f20042b99.jpg", "/images/5aab7ba5d180.jpg", "/images/b4cdc1a59abc.jpg"], text: "I added their open hex bar to my garage gym. I was impressed with the ordering process and communication from Steve. The bar itself is budget friendly compared to other brands, and I'm extremely happy with the quality of the product. Looking forward to programming hex bar deadlifts and farmer carries.", reply: "Thanks for your review! I'm really happy you like the bar!" },
  { name: "tiger hours", meta: "5 reviews", when: "5 months ago", rating: 5, photos: ["/images/756db4ca9cf9.jpg", "/images/6bfe94dd5509.jpg"], text: "The owner provided great customer service. One of the products I purchased was the wrong colour and the owner arranged the collection and delivery of the replacement, plus offered an additional small item free of charge. No problem recommending this company — a business worth supporting." },
  { name: "Jason", meta: "1 review", when: "5 months ago", rating: 5, text: "I did a reasonable amount of research before ultimately buying all my equipment here. I've had it a few months now and I'm very happy with the design, quality and pricing. I was grateful for the excellent and unexpectedly genuine advice from Steven. Very much recommend Cyberfit." },
  { name: "Jetts Joyner", meta: "1 review", when: "2 months ago", rating: 5, text: "Highly recommend! Having dealt with Steven a few times, I can say the service level is of rare high quality, and the products and price are great as well.", reply: "Thanks for your review, I'm really happy to have you as a long term customer!" },
  { name: "Lewis Squadrito", meta: "1 review", when: "6 months ago", rating: 5, text: "Cyberfit is the best place to get high quality gear. If you need any assistance, they are quick, reliable and fair! As a gym owner, I highly recommend them!" },
  { name: "Andrew Steel", meta: "Local Guide · 214 reviews", when: "2 years ago", rating: 5, photos: ["/images/5a058b5a9350.jpg", "/images/825e0fad6821.jpg"], text: "5 star after-sales service, absolutely no questions asked backup onsite for my dumbbells backing up the 3 year warranty. Would definitely recommend. Great range too.", reply: "Thanks for your review Andrew! I really appreciate your kind words." },
  { name: "Elias Potamianos", meta: "Local Guide · 31 reviews", when: "a year ago", rating: 5, text: "Steve has been amazing to deal with. Product was slightly out of warranty yet he still went out of his way to ensure customer satisfaction was maintained. This is what we call good old fashioned customer service! Will definitely be recommending to others.", reply: "Thanks so much for your kind words!" },
  { name: "Sarah M", meta: "Local Guide · 42 reviews", when: "5 years ago", rating: 5, text: "Could not have asked for better service! Fast shipping even in lockdown. Even though the spring collars didn't arrive, when I contacted the team they responded immediately and had them out to me the same day. Product quality and price is excellent." },
  { name: "Davin Annamalay", meta: "Local Guide · 151 reviews", when: "6 months ago", rating: 5, text: "Great place for fitness and health minded people. Fantastic customer service, great equipment!" },
  { name: "Adrian Romanin", meta: "8 reviews", when: "4 years ago", rating: 5, text: "Top quality service, product and business. Owner was very responsive to emails and very helpful throughout the purchase process." },
  { name: "NN (na20va)", meta: "Local Guide · 50 reviews", when: "6 years ago", rating: 5, text: "I initially considered purchasing Cyberfit's products given their excellent Google reviews. Steve is very responsive and the cage and attachments I purchased are well built and can take some punishment. Strongly recommend." },
  { name: "Benny Wong", meta: "Local Guide · 43 reviews", when: "a year ago", rating: 5, text: "Steve is one of the most sincere and friendly sales people you could ever meet. A+++ for service, products and great prices!! I would highly recommend this place!!", reply: "That's very nice of you to say so! Thank you so much!" },
  { name: "Vinayak Neliath", meta: "Local Guide · 21 reviews", when: "6 years ago", rating: 5, text: "Just finished putting together my rack and bench set. Totally hassle-free experience and no upselling, which was hugely appreciated. Equipment is simple, no-nonsense and at a very fair price. Strongly recommended.", reply: "Thanks for your review! I look forward to serving you again in the future." },
  { name: "Doctor Doctor", meta: "Local Guide · 17 reviews", when: "4 years ago", rating: 5, text: "The prices seemed a bit too good so I was slightly suspicious when I made a large purchase. However my package arrived earlier than expected and in good condition. Happy with my purchase.", reply: "Thanks for your review, I'm glad the equipment quality and condition was good!" },
  { name: "Tin Siharath", meta: "Local Guide · 20 reviews", when: "6 years ago", rating: 5, text: "Very fast response time with delivery and communication on all my purchases so far. Super friendly and I really appreciate the team going above and beyond with regular updates. Can't be any happier with my experience!" },
  { name: "Franc", meta: "Local Guide · 32 reviews", when: "4 years ago", rating: 5, text: "I recently purchased some weight training equipment from Cyberfit and couldn't be happier. The entire process from ordering to collection was great. Steve is extremely helpful and courteous." },
  { name: "Will Geeves", meta: "1 review", when: "3 years ago", rating: 5, text: "Great price and service, ordered a pair of Nuobells on preorder and got them without any trouble. After a few months I had an issue with one but they promptly fixed it under warranty without any fuss.", reply: "I do love the Nuobells! We were happy to help with the dumbbell warranty issue." },
  { name: "Dave-oh", meta: "Local Guide · 144 reviews", when: "9 years ago", rating: 5, text: "Nice guy. Bought a power rack from here back in 2008! It is still holding strong and robust. Got a whole bunch of weight lifting equipment from here and the quality, price and durability are second to none." },
  { name: "Beau Gordon", meta: "Local Guide · 20 reviews", when: "4 years ago", rating: 5, text: "I am over the moon with my commercial package deal purchased through Cyberfit. The HD1 power rack is strong, sturdy and well made. The 510UB bench is comfortable and the Olympic plates are solid." },
  { name: "P A", meta: "Local Guide · 69 reviews", when: "6 years ago", rating: 5, text: "Wow! What a great business, went out of their way at every stage of the transaction and then after-sales follow up to ensure everything was perfect for me. The best supplier of equipment and expert advice." },
  { name: "Danny T", meta: "Local Guide · 21 reviews", when: "4 years ago", rating: 5, text: "I've had great experiences with Cyberfit. Support and help is actually there. Steve has been an amazing person helping me with my enquiries and is prompt to answer them. I will definitely buy more products." },
  { name: "Nic W", meta: "Local Guide · 21 reviews", when: "6 years ago", rating: 5, text: "Great pricing, service and quality of equipment. I have a few purchases from here without issue and have been very happy with the items. This was also in the midst of the pandemic." },
  { name: "jonnies", meta: "188 reviews", when: "3 years ago", rating: 5, photos: ["/images/b30591faef89.png", "/images/da6262764a2c.jpg"], text: "These guys are unbeatable for value, quality and range. Love my new gym mats and kettlebells. I will be back — you have a lot of high-level items you can't find in other stores.", reply: "Thanks for your review, I look forward to helping with your next equipment purchase!" },
  { name: "WENQI HAN", meta: "Local Guide · 11 reviews", when: "5 years ago", rating: 5, text: "Very nice service and good price! I highly recommend this shop! I purchased the rack, the Olympic bar and weight plates — the quality of the rack is super good, the same as a commercial gym!" },
  { name: "Brad", meta: "Local Guide · 13 reviews", when: "3 years ago", rating: 5, text: "Great high quality equipment, friendly owner and I've had no problems with everything I've bought. I come back every time I need something. If I could I'd give you a 6th star!!", reply: "Thanks so much, it means a lot to have happy customers who plan on coming back!" },
  { name: "Gino Soliman", meta: "Local Guide · 49 reviews", when: "5 years ago", rating: 5, text: "Very happy with my purchase. I preordered a not-in-stock item and I got it close to the given ETA date. Friendly owner and very knowledgeable. Would shop here again.", reply: "Thanks Gino, I really appreciate your feedback!" },
  { name: "Coach Ali", meta: "Local Guide · 47 reviews", when: "6 years ago", rating: 5, text: "I received exceptional service from Cyberfit. The product is great and Steve is a professional. I'll be back for sure!" },
  { name: "a i", meta: "11 reviews", when: "3 years ago", rating: 5, text: "Bought a power rack more than 5 years ago, still going strong. The guy who runs the place is a top bloke. Just bought a leg extension for my bench and got it cheaper than advertised.", reply: "I'm so glad to hear the rack is still doing the job in your home gym!" },
  { name: "Connor Evans", meta: "Local Guide · 70 reviews", when: "2 years ago", rating: 5, text: "Went to this place on a Saturday to pick up a folding gym mat, absolutely outstanding service, can't wait to use it!", reply: "Thanks so much for your kind words, hope to see you again soon!" },
  { name: "Anne Mongauzy", meta: "4 reviews", when: "5 years ago", rating: 5, text: "Great service, very prompt in response to emails even during busy lockdown. Product was great." },
  { name: "jaron blackie", meta: "Local Guide · 41 reviews", when: "6 years ago", rating: 5, text: "These guys normally always give me a good price. I have been buying equipment for my outdoor boot camps from here for years." },
  { name: "Aaron Valverde", meta: "Local Guide · 68 reviews", when: "6 years ago", rating: 5, text: "Awesome products and the easiest company to buy from, nothing is too much trouble, even late changes to an order." },
  { name: "Ben Jamieson", meta: "Local Guide · 236 reviews", when: "4 years ago", rating: 5, text: "Good convenient weekday pick for gym equipment. Easy to park and good customer service." },
  { name: "Alex Aguilar", meta: "Local Guide · 21 reviews", when: "6 years ago", rating: 5, text: "Great service and prices! Quality equipment which I couldn't be happier with. Cheers!" },
  { name: "John Callaghan", meta: "1 review", when: "9 years ago", rating: 5, text: "Awesome, great company to deal with, top equipment and very professional staff who know their stuff! I will be back!" },
  { name: "Andrew Wood", meta: "Local Guide · 57 reviews", when: "8 years ago", rating: 5, text: "Excellent service and excellent prices. You won't find anything better than Cyberfit!", reply: "Thank you! I really appreciate your review." },
  { name: "Guy Keeghan", meta: "Local Guide · 164 reviews", when: "7 years ago", rating: 5, text: "Been going to these guys for 10 years. Always helpful and reasonable prices.", reply: "It's been fantastic having you come back all this time! It means a lot that you have faith in our products." },
  { name: "Steviie Vee", meta: "12 reviews", when: "7 years ago", rating: 5, text: "Good customer service, polite, very helpful and good price.", reply: "Thanks Steviie! I hope the equipment is working out well for you." },
];

export const brands = [
  "BODY-SOLID",
  "NÜOBELL",
  "YORK",
  "JX FITNESS",
  "TOTAL GYM",
  "ERCOLINA",
];

export const faqs = [
  {
    q: "Do you deliver Australia-wide?",
    a: "Yes. We ship right across Australia with fully insured delivery on every order. Metro orders typically arrive within 3-7 business days, with regional and remote areas taking a little longer. You'll receive tracking updates by email once your order is dispatched.",
  },
  {
    q: "Is there a warranty on your equipment?",
    a: "Absolutely. All of our steel frames are guaranteed for the life of the product, and every item is covered by our warranty and 100% money-back guarantee. We've been backing our gear this way since 2004.",
  },
  {
    q: "Do you offer free gym design services?",
    a: "We do. Our in-house mechanical engineers provide free gym design and space-planning advice for both home and commercial fit-outs. Send us your room dimensions and goals and we'll recommend the right equipment for your space and budget.",
  },
  {
    q: "Can I see the equipment before I buy?",
    a: "Yes — you're welcome to visit our Sydney showroom in Seven Hills, NSW. We're open Monday to Friday 10am-4pm and Saturday 10am-2pm, with after-hours pickup by arrangement. If you're outside NSW we also offer video walk-throughs.",
  },
  {
    q: "Do you assemble or install the equipment?",
    a: "Most home equipment is easy to self-assemble with the included instructions and hardware. For larger commercial machines and full fit-outs we can arrange professional installation — just ask our team for a quote.",
  },
  {
    q: "What payment options do you accept?",
    a: "We accept all major credit cards, PayPal and bank transfer. Buy-now-pay-later options are available at checkout so you can spread the cost of your new gym over time.",
  },
];

export const footer = {
  address: ["Cyberfit Gym Equipment", "Unit 27, 14 Stanton Rd", "Seven Hills", "NSW 2147 Australia"],
  openTimes: ["Weekdays: 10am to 4pm", "Saturday: 10am to 2pm", "After hours pickup available."],
  contact: { email: "enquiries@cyberfit.com.au", phone: "+61 2 9620 6635" },
  browse: [
    "Strength Training",
    "Cardio",
    "Package Deals",
    "Functional Training",
    "Flooring & Mirrors",
    "Boxing & MMA Gear",
    "Accessories",
  ],
  customer: ["Contact Us", "Gym Fitouts", "Shipping & Returns", "Terms of Use", "Privacy Policy", "My Account", "Our Brands"],
};

// ---------------- VERSION 2 (redesign) data ----------------
export const v2 = {
  heroBg:
    "/images/a96833d911bc.jpg",
  heroSide:
    "/images/d47fa302bf1c.jpg",
  stats: [
    { value: "20+", label: "Years in business" },
    { value: "4.8", label: "Google rating" },
    { value: "50k+", label: "Aussies trained" },
    { value: "Life", label: "Frame warranty" },
  ],
  lifestyle: {
    strength: {
      eyebrow: "Strength Training",
      title: "Built for every body",
      text: "From your first pair of dumbbells to a full commercial rig, our strength range is engineered to grow with you. Commercial-grade steel, guaranteed for life.",
      cta: "Shop Strength",
      image:
        "/images/b4cdc1a59abc.jpg",
    },
    cardio: {
      eyebrow: "Cardio Machines",
      title: "Go the distance, at home",
      text: "Treadmills, bikes and rowers from Sole, Matrix and York deliver true gym performance in your living room. Quiet, durable and built to last.",
      cta: "Shop Cardio",
      image:
        "/images/d01323505bff.jpg",
    },
  },
  ctaBg:
    "/images/5a058b5a9350.jpg",
  editorial: [
    {
      id: "strength",
      name: "Strength Training",
      count: "346 products",
      image:
        "/images/5aab7ba5d180.jpg",
      span: "big",
    },
    {
      id: "cardio",
      name: "Cardio Machines",
      count: "61 products",
      image:
        "/images/432ee2cac499.jpg",
      span: "small",
    },
    {
      id: "functional",
      name: "Functional Training",
      count: "Trainers & cables",
      image:
        "/images/b6f23d78489f.jpg",
      span: "small",
    },
    {
      id: "flooring",
      name: "Gym Flooring & Mirrors",
      count: "Fit-out ready",
      image:
        "/images/50dc6bdecf7a.jpg",
      span: "wide",
    },
  ],
};


// More products for Version 2 modules
export const deals = [
  {
    id: "freebeat-boom-bike",
    name: "Freebeat Boom Bike",
    price: 649,
    compareAt: 1049,
    rating: 4.7,
    image:
      "/images/4fc6eb35823c.jpg",
  },
  {
    id: "cyberfit-7415-treadmill",
    name: "Cyberfit 7415 2.0CHP Treadmill",
    price: 995,
    compareAt: 1495,
    rating: 4.6,
    image:
      "/images/f669cf089b8a.jpg",
  },
  {
    id: "morgan-endurance-bag",
    name: "Morgan V2 Endurance Boxing Bag",
    price: 285,
    compareAt: 299,
    rating: 4.8,
    image:
      "/images/d5bea146125b.jpg",
  },
  {
    id: "sole-f63-treadmill",
    name: "Sole F63 Treadmill",
    price: 2495,
    compareAt: 2999,
    rating: 4.9,
    image:
      "/images/74dc5853605d.jpg",
  },
  {
    id: "pure-design-sb4",
    name: "Pure Design SB4 V2 Spin Bike",
    price: 695,
    compareAt: 849,
    rating: 4.7,
    image:
      "/images/56728ae97d82.png",
  },
  {
    id: "5kg-olympic-plates",
    name: "5kg Olympic Weight Plates Rubber",
    price: 40,
    compareAt: 60,
    rating: 4.8,
    image:
      "/images/50dc7656784d.jpg",
  },
  {
    id: "morgan-tri-max-bag",
    name: "Morgan Tri Max Free Standing Punch Bag",
    price: 729,
    compareAt: 749,
    rating: 4.7,
    image:
      "/images/1269a04c48dc.jpg",
  },
  {
    id: "rubber-gym-tile-15mm",
    name: "Rubber Gym Flooring Tile 1m x 1m x 15mm",
    price: 29.9,
    compareAt: 39,
    rating: 4.9,
    image:
      "/images/df8b80203b60.jpg",
  },
];

export const newArrivals = [
  {
    id: "matrix-rower",
    name: "Matrix Rower New Version",
    price: 2495,
    compareAt: 2899,
    rating: 4.9,
    image:
      "/images/bd1f6f3c6e7a.jpg",
  },
  {
    id: "smith-platinum",
    name: "Smith Machine Commercial Platinum",
    price: 4495,
    compareAt: 4995,
    rating: 4.9,
    image:
      "/images/61bcb911e129.png",
  },
  {
    id: "strength-station",
    name: "Strength Station Dual Cable Machine",
    price: 2195,
    compareAt: 2695,
    rating: 4.8,
    image:
      "/images/9e9e67c5a96f.jpg",
  },
  {
    id: "hex-set-40kg",
    name: "Rubber Hex Dumbbells Set 2-40kg with 4 Tier Rack",
    price: 2511,
    compareAt: 2790,
    rating: 4.9,
    image:
      "/images/c9955a00f364.jpg",
  },
];


// Hero "Top Sellers" showcase — real product data from cyberfit.com.au
export const topSellers = [
  {
    id: "nuobell-2-32kg",
    brand: "NÜOBELL",
    name: "NÜOBELL 2-32kg Adjustable Dumbbells Pair",
    price: 1095,
    compareAt: 1295,
    rating: 5.0,
    reviews: 57,
    badge: "Best Seller",
    image: "/images/ts-nuobell.jpg",
    blurb:
      "All-in-one 2-32kg dumbbells with 2kg increments. Machined steel plates and rust-proof aluminium handles, backed by an industry-leading 3 year warranty.",
    highlights: ["2-32kg in 2kg steps", "Machined steel plates", "3 year warranty"],
  },
  {
    id: "cyberfit-smith-functional-trainer",
    brand: "CYBERFIT",
    name: "Cyberfit Smith Functional Trainer Machine",
    price: 4995,
    compareAt: 8995,
    rating: 0,
    reviews: 0,
    badge: "Save 45%",
    image: "/images/ts-smith.png",
    blurb:
      "One machine to rule them all — a heavy-duty Smith machine and functional trainer with dual 100kg steel stacks, adjustable tornado arms and a lifetime frame guarantee.",
    highlights: ["2 x 100kg steel stacks", "Adjustable tornado arms", "Lifetime frame guarantee"],
  },
  {
    id: "glassless-gym-mirrors",
    brand: "CYBERFIT",
    name: "Glassless Shatterproof Gym Mirrors",
    price: 349,
    compareAt: 395,
    rating: 5.0,
    reviews: 1,
    badge: "Safe & Light",
    image: "/images/ts-mirrors.jpg",
    blurb:
      "All the benefits of a glass mirror with none of the risk. Just 3.5kg per panel for easy DIY mounting, with a perfectly flat, distortion-free image.",
    highlights: ["Shatterproof polymer", "Only 3.5kg per panel", "DIY wall mount"],
  },
  {
    id: "15mm-rubber-gym-mat",
    brand: "EZFLOOR",
    name: "15mm Rubber Gym Flooring Tile 1m x 1m Black",
    price: 29.9,
    compareAt: 39,
    rating: 4.7,
    reviews: 7,
    badge: "Commercial Grade",
    image: "/images/ts-rubbermat.jpg",
    blurb:
      "AS-standards commercial rubber tile made from 100% recycled rubber. Slip-resistant, zero-odour and 15mm thick for a no-glue, loose-lay install.",
    highlights: ["AS compliant", "100% recycled rubber", "2 year commercial warranty"],
  },
];


// ---- Product detail page: 90kg Olympic Weight Set (from cyberfit-au.myshopify.com) ----
const CDN = "/images/";
export const productDetail = {
  slug: "90kg-olympic-weight-set-rubber-coated",
  sku: "OPR90",
  name: "90kg Olympic Weight Set Rubber Coated",
  brand: "CYBERFIT",
  price: 395,
  compareAt: 595,
  rating: 4.9,
  reviews: 31,
  shortDesc:
    "90kg Olympic weight set from Cyberfit. If you're just getting into lifting this set is a great place to start — it includes all the popular increments from 5kg to 20kg plus a heavy-duty 1000lb rated barbell that will never become redundant, no matter what your future lifts are.",
  images: [
    CDN + "opr100-1600_2_d5b2909d-44dd-47ef-bb94-a125628e8f09.jpg?v=1768268458&width=900",
    CDN + "olympic-plates-1-25kg_2.jpg?v=1768268458&width=900",
    CDN + "obar220a_3.jpg?v=1768268458&width=900",
    CDN + "obar220-knurl_2.jpg?v=1768268459&width=900",
    CDN + "obar220-end-sleeve_2.jpg?v=1768268458&width=900",
    CDN + "olympic-spring-collars-1000_3.jpg?v=1768268458&width=900",
  ],
  highlights: [
    "2x 20kg, 2x 10kg, 2x 5kg rubber-coated plates (70kg)",
    "1000lb-rated 7ft (220cm) Olympic barbell",
    "Unbreakable spring safety collars included",
    "Stainless steel plate sleeves — will never rust",
  ],
  atGlance: [
    "Stainless steel centre sleeves are moulded right into the rubber to prevent them being knocked out. The splayed opening prevents the sleeve edge from chipping your bars and racks — one of the reasons we supply so many of these plates to commercial users. Curved easi-grip handles offer fantastic comfort and superior grip.",
    "Unbreakable spring safety collars are bullet-proof and quick to use with one hand, as specified by our commercial clients. They won't put dents in your chromed bar as there's no locking screw required.",
    "The bar is 1000lb rated, 7' Olympic 220cm length, 30mm diameter, with 50mm rotating solid steel ends running 2 bearings and 2 bushes. Circlip-encapsulated ends never come loose or need tightening.",
  ],
  specs: [
    {
      title: "OBAR220 Barbell — 20kg",
      items: [
        "7 foot (220cm) length, 50mm solid steel end sleeves",
        "Circlip fastener & end cap for easy servicing — never comes loose",
        "450kg (1000lb) maximum load capacity",
        "Knurled, chrome coated finish",
        "IPF & IWF power rings at 810mm and 910mm",
        "Mild centre knurl for squatting",
      ],
    },
    {
      title: "OPR Weight Plates — 70kg total",
      items: [
        "Steel core with hard-wearing rubber coated finish",
        "Grip handles for easy one-handed pickup — use like kettlebells",
        "Stainless steel sleeves will never rust; splayed profile protects equipment",
        "Includes 2x 20kg, 2x 10kg, 2x 5kg (other configs on request)",
      ],
    },
  ],
  faqs: [
    { q: "What is the Cyberfit Money-Back Guarantee?", a: "We give you 30 days to decide whether the product is right for you. Provided it hasn't been used and is in its original packaging, returns are accepted without question." },
    { q: "What does your Lifetime Frame Guarantee cover?", a: "All Cyberfit branded products are covered against faulty welds, cracks in the frame, or anything that would seriously shorten the life of the product. All Cyberfit products carry a 2 year warranty, domestic or commercial." },
    { q: "Can I get help choosing the right equipment?", a: "Yes! We welcome your questions about which items suit you best based on your fitness goals, available space, number of users and budget. Our founder is a mechanical engineer who rejects low-quality products." },
    { q: "Why buy from Cyberfit?", a: "We've been doing this for over 20 years. The owner is involved with every customer and every sale — you won't be hounded by a commission-earning employee. We engineer well-made products that last and stand behind them." },
  ],
  relatedIds: ["ws-100kg", "ws-140kg", "ws-150kg", "ws-180kg"],
};

// ---- Category page: Weight Sets collection ----
const C = (f) => CDN + f + "?width=500";
export const weightSetsCollection = {
  title: "Weight Sets",
  breadcrumb: ["Home", "Strength Training", "Weight Plates & Bars", "Weight Sets"],
  description:
    "Rubber-coated Olympic weight sets and bumper plate packages built for home and commercial gyms. Every set is matched with a heavy-duty barbell and backed by our 30-day money-back guarantee and 2 year warranty.",
  products: [
    { id: "ws-20kg-pump", slug: "20kg-pump-bar-set", name: "20kg Pump Bar Set", price: 109, compareAt: 169, rating: 4.7, image: C("2013617132850-314.jpg") },
    { id: "90kg-olympic-set", slug: "90kg-olympic-weight-set-rubber-coated", name: "90kg Olympic Weight Set Rubber Coated", price: 395, compareAt: 595, rating: 4.9, image: C("opr100-1600_2_d5b2909d-44dd-47ef-bb94-a125628e8f09.jpg") },
    { id: "ws-100kg", slug: "100kg-olympic-weight-set-rubber-coated", name: "100kg Olympic Weight Set Rubber Coated", price: 431, compareAt: 655, rating: 4.9, image: C("opr100-1600.jpg") },
    { id: "ws-140kg", slug: "140kg-olympic-weight-set-rubber-coated", name: "140kg Olympic Weight Set Rubber Coated", price: 575, compareAt: 895, rating: 4.8, image: C("opr140-1600.jpg") },
    { id: "ws-150kg", slug: "150kg-olympic-weight-set-rubber-coated", name: "150kg Olympic Weight Set Rubber Coated", price: 595, compareAt: 955, rating: 4.9, image: C("opr150-olympic-weight-set-150kg-800.jpg") },
    { id: "ws-180kg", slug: "olympic-weight-set-rubber-coated-180kg", name: "Olympic Weight Set Rubber Coated 180kg", price: 695, compareAt: 1135, rating: 4.8, image: C("opr180-800.jpg") },
    { id: "ws-190kg", slug: "olympic-weight-set-rubber-coated-190kg", name: "Olympic Weight Set Rubber Coated 190kg", price: 755, compareAt: 1195, rating: 4.8, image: C("olympic-weight-set-rubber-with-bar-opr190.jpg") },
    { id: "ws-250kg", slug: "olympic-weight-set-rubber-coated-250kg", name: "Olympic Weight Set Rubber Coated 250kg", price: 969, compareAt: 1555, rating: 4.9, image: C("opr250-600.jpg") },
    { id: "ws-plates-200kg", slug: "olympic-rubber-coated-weight-plates-200kg-pack", name: "Olympic Rubber Coated Weight Plates 200kg Pack", price: 720, compareAt: 1200, rating: 4.8, image: C("olympic-plates-200kg-500x500.jpg") },
    { id: "ws-econ-100kg", slug: "econ-100kg-olympic-bumper-plates-set", name: "Econ 100kg Olympic Bumper Plates Set", price: 479, compareAt: 650, rating: 4.7, image: C("eco100-v2.jpg") },
    { id: "ws-econ-150kg", slug: "econ-150kg-olympic-bumper-plates-set", name: "Econ 150kg Olympic Bumper Plates Set", price: 695, compareAt: 975, rating: 4.7, image: C("eco150-v2.jpg") },
    { id: "ws-elite-60kg", slug: "olympic-bumper-plates-set-60kg-elite-bumpers", name: "Olympic Bumper Plates Set 60kg ELITE", price: 480, compareAt: 784, rating: 4.9, image: C("ELITE60-800x.jpg") },
    { id: "ws-elite-90kg", slug: "olympic-bumper-plates-set-90kg-elite-bumpers", name: "Olympic Bumper Plates Set 90kg ELITE", price: 720, compareAt: 1068, rating: 4.9, image: C("ELITE90-800x.jpg") },
    { id: "ws-elite-100kg", slug: "olympic-bumper-plates-set-100kg-elite-bumpers", name: "Olympic Bumper Plates Set 100kg ELITE", price: 800, compareAt: 1220, rating: 4.9, image: C("ELITE100-800x.jpg") },
    { id: "ws-elite-140kg", slug: "olympic-bumper-plates-set-140kg-elite-bumpers", name: "Olympic Bumper Plates Set 140kg ELITE", price: 1120, compareAt: 1589, rating: 4.8, image: C("ELITE140-800x.jpg") },
    { id: "ws-elite-150kg", slug: "olympic-bumper-plates-set-150kg-elite-bumpers", name: "Olympic Bumper Plates Set 150kg ELITE", price: 1200, compareAt: 1742, rating: 4.9, image: C("elite150-1600x1600.jpg") },
    { id: "ws-elite-127kg", slug: "olympic-bumper-plates-set-127kg-with-1000lb-bar", name: "Olympic Bumper Plates Set 127kg with 1000lb Bar", price: 1371, compareAt: 1443, rating: 4.9, image: C("elite132-bumper-plates-set-1026.jpg") },
    { id: "ws-elite-160kg", slug: "olympic-bumper-plates-set-160kg-with-1000lb-bar", name: "Olympic Bumper Plates Set 160kg with 1000lb Bar", price: 1667, compareAt: 1754, rating: 4.9, image: C("ELITE160-800.jpg") },
    { id: "ws-elite-167kg", slug: "olympic-bumper-plates-set-167kg-bumper-with-1000lb-bar", name: "Olympic Bumper Plates Set 167kg with 1000lb Bar", price: 1722, compareAt: 1812, rating: 4.8, image: C("ELITE172-800.jpg") },
    { id: "ws-elite-177kg", slug: "olympic-bumper-plates-set-177kg-with-1000lb-bar", name: "Olympic Bumper Plates Set 177kg with 1000lb Bar", price: 1867, compareAt: 1965, rating: 4.8, image: C("ELITE182-800.jpg") },
  ],
};


// ---- Collections (category pages), built from existing product data ----
const pick = (arr, ids) => ids.map((id) => arr.find((x) => x.id === id)).filter(Boolean);

export const collections = {
  "weight-sets": weightSetsCollection,
  "strength-training": {
    title: "Strength Training",
    breadcrumb: ["Home", "Strength Training"],
    eyebrow: "Build muscle",
    description:
      "Racks, benches, machines and free weights engineered for serious lifting. Commercial-grade steel, guaranteed for life and shipped fully insured Australia-wide.",
    products: [...bestSellers],
  },
  "cardio-machines": {
    title: "Cardio Machines",
    breadcrumb: ["Home", "Cardio"],
    eyebrow: "Go the distance",
    description:
      "Treadmills, exercise bikes and rowers from Sole, Matrix and Cyberfit — true gym performance for your home, quiet and built to last.",
    products: [
      ...pick(deals, ["freebeat-boom-bike", "cyberfit-7415-treadmill", "sole-f63-treadmill", "pure-design-sb4"]),
      ...pick(newArrivals, ["matrix-rower"]),
    ],
  },
  "adjustable-dumbbells": {
    title: "Adjustable Dumbbells",
    breadcrumb: ["Home", "Strength Training", "Dumbbells"],
    eyebrow: "Save space",
    description:
      "NÜOBELL adjustable dumbbells and rubber hex sets — replace a whole rack with a single pair. The fastest changing adjustable dumbbells on the planet.",
    products: [
      ...topSellers.filter((x) => x.id === "nuobell-2-32kg"),
      ...pick(bestSellers, ["hex-dumbbell-set"]),
      ...pick(newArrivals, ["hex-set-40kg"]),
    ],
  },
  "gym-flooring": {
    title: "Gym Flooring & Mirrors",
    breadcrumb: ["Home", "Flooring & Mirrors"],
    eyebrow: "Fit-out ready",
    description:
      "Loose-laid commercial rubber flooring and shatterproof glassless mirrors for home gyms, studios and full commercial facilities.",
    products: [
      ...topSellers.filter((x) => ["15mm-rubber-gym-mat", "glassless-gym-mirrors"].includes(x.id)),
      ...pick(deals, ["rubber-gym-tile-15mm"]),
    ],
  },
  "functional-training": {
    title: "Functional Training",
    breadcrumb: ["Home", "Functional Training"],
    eyebrow: "Train every plane",
    description:
      "Functional trainers, cable crossovers, Smith machines and multistations for full-body, full-range training at home or in a commercial gym.",
    products: [
      ...topSellers.filter((x) => x.id === "cyberfit-smith-functional-trainer"),
      ...pick(bestSellers, ["functional-trainer-commercial", "c80-package"]),
      ...pick(newArrivals, ["smith-platinum", "strength-station"]),
    ],
  },
  "package-deals": {
    title: "Package Deals",
    breadcrumb: ["Home", "Package Deals"],
    eyebrow: "Complete setups",
    description:
      "Ready-to-train home and commercial gym packages at bundle pricing — everything you need in one order, backed by expert setup advice.",
    products: [
      ...pick(bestSellers, ["c80-package", "york-enforcer", "leg-press-hack"]),
      ...pick(deals, ["freebeat-boom-bike"]),
    ],
  },
};

// ---- Product details lookup ----
export const productDetails = {
  [productDetail.slug]: productDetail,
};

export function findProduct(slug) {
  if (productDetails[slug]) return productDetails[slug];
  let p = null;
  for (const key in collections) {
    p = collections[key].products.find((x) => (x.slug || x.id) === slug);
    if (p) break;
  }
  if (!p) [bestSellers, deals, newArrivals, topSellers].forEach((arr) => {
    if (!p) p = arr.find((x) => (x.slug || x.id) === slug);
  });
  if (!p) return productDetail;
  return {
    slug: p.slug || p.id,
    sku: (p.id || "").toUpperCase().slice(0, 12),
    name: p.name,
    brand: p.brand || "CYBERFIT",
    price: p.price,
    compareAt: p.compareAt || null,
    rating: p.rating || 4.8,
    reviews: p.reviews || 18,
    images: [p.image],
    shortDesc:
      p.blurb ||
      `${p.name} from Cyberfit Gym Equipment. Premium, commercial-grade quality that's built to last — backed by our lifetime frame guarantee, 2 year warranty and fully insured Australia-wide delivery.`,
    highlights:
      p.highlights || [
        "Commercial-grade build quality",
        "Steel frames guaranteed for life",
        "Fully insured Australia-wide delivery",
        "30-day money back guarantee",
      ],
    atGlance: [
      `Designed in-house by our mechanical-engineer founder, the ${p.name} is built to a minimum standard we'd happily own ourselves — no short cuts to shave costs.`,
      "Every Cyberfit product is covered by a 2 year warranty (domestic or commercial) and our lifetime frame guarantee, and is dispatched with fully insured delivery right across Australia.",
    ],
    specs: [],
    faqs: productDetail.faqs,
    relatedIds: [],
  };
}

// ---- Static / internal pages ----
export const staticPages = {
  about: {
    title: "Our Story",
    eyebrow: "About Cyberfit",
    intro:
      "Starting out in a garage in 2004, Cyberfit has grown into one of Australia's most trusted names in home and commercial gym equipment.",
    sections: [
      { heading: "Engineered, not just imported", body: "Cyberfit was founded by a mechanical engineer with a passion for building long-lasting gym equipment to be proud of. We reject low-quality products — if we wouldn't put it in our own gym, we won't sell it to you." },
      { heading: "Two decades of trust", body: "We've been doing this for over 20 years, and that's a big part of why we're still here. The owner is involved with every customer and every sale, so you're never hounded by a commission-earning salesperson." },
      { heading: "A real business behind the website", body: "We operate a genuine showroom and stocked warehouse in Seven Hills, Sydney. Come and test the equipment in person, or order online with fully insured delivery Australia-wide." },
    ],
  },
  contact: {
    title: "Contact Us",
    eyebrow: "We're here to help",
    intro: "Questions about a product or a full gym fit-out? Talk to our Australian team 7 days a week.",
    contact: true,
    sections: [
      { heading: "Free expert advice", body: "We welcome your questions about which items suit you best based on your goals, space, number of users and budget. Call Steve directly on 02 9620 6635." },
    ],
  },
  "shipping-returns": {
    title: "Shipping & Returns",
    eyebrow: "Buy with confidence",
    intro: "Fully insured delivery Australia-wide and a no-questions 30-day money-back guarantee.",
    sections: [
      { heading: "Australia-wide shipping", body: "We dispatch orders quickly from our Seven Hills warehouse. Metro orders typically arrive within 3-7 business days; regional and remote areas take a little longer. Every order is fully insured door to door and you'll receive tracking by email." },
      { heading: "30-day money-back guarantee", body: "We understand you can't physically see a product when shopping online, so we give you 30 days to decide. Provided the item hasn't been used and is in its original packaging, returns are accepted without question." },
      { heading: "Warranty", body: "All Cyberfit products carry a 2 year warranty, domestic or commercial, plus a lifetime frame guarantee covering faulty welds and cracks. Third-party brands are covered by their own factory-backed warranties." },
    ],
  },
  "gym-fitouts": {
    title: "Gym Fitouts",
    eyebrow: "Design service",
    intro: "Free gym design and space-planning for home, garage and commercial facilities.",
    sections: [
      { heading: "Free space planning", body: "Send us your room dimensions and goals and our engineers will recommend the right equipment and layout for your space and budget — whether it's a single-car garage or a 24/7 commercial facility." },
      { heading: "Trusted by the pros", body: "Our commercial-grade flooring and equipment are used by facilities right across Australia. We'll help you specify a fit-out that lasts and keeps members coming back." },
    ],
  },
  brands: {
    title: "Our Brands",
    eyebrow: "Quality partners",
    intro: "We hand-pick the brands we stock — the same standard we hold our own equipment to.",
    sections: [
      { heading: "The brands we trust", body: "Body-Solid, NÜOBELL, York, JX Fitness, Total Gym, Sole, Matrix and Ercolina — alongside our own in-house engineered Cyberfit range. Every brand is chosen for durability, performance and value." },
    ],
  },
  terms: {
    title: "Terms of Use",
    eyebrow: "Legal",
    intro: "The terms that apply when you use the Cyberfit website and purchase from us.",
    sections: [
      { heading: "Using this site", body: "By accessing this website you agree to use it lawfully and not to misuse its content. Product images and descriptions are provided in good faith; specifications may change as products are improved." },
      { heading: "Pricing & orders", body: "All prices are in AUD and include GST unless stated. We reserve the right to correct pricing errors and to accept or decline any order." },
    ],
  },
  privacy: {
    title: "Privacy Policy",
    eyebrow: "Your data",
    intro: "How Cyberfit collects, uses and protects your personal information.",
    sections: [
      { heading: "What we collect", body: "We only collect the information needed to process your order and provide support — such as your name, contact details and delivery address. We never sell your data." },
      { heading: "How we use it", body: "Your details are used to fulfil orders, provide warranty support and, if you opt in, to send occasional offers. You can unsubscribe at any time." },
    ],
  },
};

